import { useEffect, useState } from "react";
import StartApp from "./components/StartApp";
import LoginRegister from "./components/loginPage";
import ConfirmaNumber from "./components/ConfirmationNumber";
import UserLogin from "./components/UserLogin";
import SignUp from "./components/SignUp";
import ForgetPassword from "./components/ForgetPassword";
import RulesSite from "../../../Web/View/RulesSite";
import CustomModal from "../../../Web/Common/Modal/CustomModal";

const StartPage = ({ isLogin, setisLogin, isWebview }) => {
    const [step, setstep] = useState(isWebview ? "step1" : "step2")

    const [showModal, setShowModal] = useState(false);

    switch (step) {
        case "step2":
            return (
                <>
                    <LoginRegister setShowModal={setShowModal} isWebview={isWebview} step={step} setStep={setstep} />
                    <ModalTrems showModal={showModal} setShowModal={setShowModal} />
                </>
            )
        case "step3":
            return (
                <UserLogin isWebview={isWebview} setStep={setstep} setisLogin={setisLogin} />
            )
        case "step4":
            return (
                <>
                    <SignUp setStep={setstep} setShowModal={setShowModal} />
                    <ModalTrems showModal={showModal} setShowModal={setShowModal} />
                </>
            )
        case "step5":
            return (
                <ConfirmaNumber isWebview={isWebview} step={step} setStep={setstep} isLogin={isLogin} setisLogin={setisLogin} />
            )
        case "step6":
            return (
                <ForgetPassword setShowModal={setShowModal} isWebview={isWebview} step={step} setStep={setstep} isLogin={isLogin} setisLogin={setisLogin} />
            )
        default:
            return (
                <StartApp setStep={setstep} />
            )
    }
}

export default StartPage;

const ModalTrems = ({ showModal, setShowModal }) => {
    return (
        <CustomModal
            header={"قوانین و مقررات"}
            show={showModal}
            handleClose={() => {
                setShowModal(false);
            }}
        // className={"modalQuickReserve"}
        >
            <RulesSite isApp={true} />
        </CustomModal>
    )
}